export default [
  {
    path: 'feeds',
    name: 'website.feeds',
    // component: () => import('@/views/website/feeds'),
    component: () => import('@/views/website/feeds/facebook-catalog/index.vue'),
  },
  // {
  //   path: 'feeds/:id',
  //   name: 'website.feeds.detail',
  //   component: () => import('@/views/website/feeds/detail'),
  // },
];
